import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=09296c1b&"
import script from "./Placeholder.vue?vue&type=script&lang=js&"
export * from "./Placeholder.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./demo.md?vue&type=custom&index=0&blockType=docs&issuerPath=%2Froot%2FOcelot-Social%2Fstyleguide%2Fsrc%2Fsystem%2Fcomponents%2Flayout%2FPlaceholder%2FPlaceholder.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports